import { render, staticRenderFns } from "./LinkModel.vue?vue&type=template&id=792716a1&scoped=true&"
import script from "./LinkModel.vue?vue&type=script&lang=js&"
export * from "./LinkModel.vue?vue&type=script&lang=js&"
import style0 from "./LinkModel.vue?vue&type=style&index=0&id=792716a1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792716a1",
  null
  
)

export default component.exports